import { ORDER_BOT, ORDER_SIDE, ORDER_STATUS } from 'shared/consts/filters';
import { EFilterColor } from 'shared/consts/filters';

import { EFilterEntity, EFilterFormatter, IFilterSchemeExtended } from '../common';

export const cexPairOrdersFiltersScheme = (options?: {
  isAdmin?: boolean;
}): Record<string, IFilterSchemeExtended> => {
  const isAdmin = options?.isAdmin ?? false;

  return {
    range: {
      type: EFilterEntity.date_range,
      label: 'Time range',
      name: 'range',
      field: 'range',
      single: true,
    },
    side: {
      type: EFilterEntity.colors_single_select,
      formatter: EFilterFormatter.colors_single_select,
      label: 'Side',
      name: 'sides',
      field: 'sides',
      listSingleColors: ORDER_SIDE,
      single: true,
    },
    statuses: {
      type: EFilterEntity.colors_multi_select,
      formatter: EFilterFormatter.colors_multi_select,
      label: 'Statuses',
      name: 'statuses',
      field: 'statuses',
      listMultiColors: ORDER_STATUS,
      single: true,
    },
    ...(isAdmin
      ? {
          bot: {
            type: EFilterEntity.colors_multi_select,
            formatter: EFilterFormatter.colors_multi_select,
            label: 'Bot',
            name: 'bot',
            field: 'bot',
            listMultiColors: [
              ...ORDER_BOT,
              //TODO remove and put it as another bot from common bots array
              {
                value: 'regular',
                label: 'Regular',
                color: EFilterColor.blue_2,
              },
            ],
            single: true,
          },
          accounts: {
            type: EFilterEntity.cex_accounts_multi_select,
            formatter: EFilterFormatter.cex_accounts_multi_select,
            label: 'Accounts',
            name: 'accounts',
            field: 'account_ids',
            single: true,
          },
        }
      : {}),
  };
};
